import React from "react";
import { Typography, Tooltip } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { IconInfoCircle } from "@tabler/icons-react";

interface InfoRowProps {
  label: string;
  value: React.ReactNode;
  tooltip?: React.ReactNode;
}

export const InfoRow: React.FC<InfoRowProps> = ({ label, value, tooltip }) => {
  return (
    <Stack direction="column" justify="between" align="start" gap="sm">
      <Stack direction="row" align="center" gap="xs">
        <Typography variant="body" className="al-text-muted-foreground" size="sm">
          {label}
        </Typography>
        {tooltip && (
          <Tooltip title={<div className="al-max-w-[300px]">{tooltip}</div>}>
            <span>
              <IconInfoCircle className="al-w-4 al-h-4 al-text-muted-foreground al-cursor-help" />
            </span>
          </Tooltip>
        )}
      </Stack>
      <div className="al-text-right">{value}</div>
    </Stack>
  );
};
